import { Layers } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

// Extrai o número da parcela do texto da descrição (ex.: "Note 3/12",
// "CUOTA: 01/03"). Exige dígitos dos dois lados; total entre 2 e 99 e n <= total.
export function parseInstallment(desc?: string | null): { n: number; total: number } | null {
  if (!desc) return null
  const m = desc.match(/\b(\d{1,3})\s*\/\s*(\d{1,3})\b/)
  if (!m) return null
  const n = parseInt(m[1], 10)
  const total = parseInt(m[2], 10)
  if (total < 2 || total > 99 || n < 1 || n > total) return null
  return { n, total }
}

// Selo compacto "N/T" para compras parceladas. Usa os campos persistidos
// (installment_no/total) quando existem; senão tenta extrair da descrição.
export function InstallmentBadge({
  n,
  total,
  description,
}: {
  n?: number | null
  total?: number | null
  description?: string | null
}) {
  const p = n && total ? { n, total } : parseInstallment(description)
  if (!p) return null
  return (
    <Badge
      variant="outline"
      className="text-primary ml-1 gap-0.5 align-middle text-[10px] font-normal"
      title={`Parcela ${p.n} de ${p.total}`}
    >
      <Layers className="size-2.5" />
      {p.n}/{p.total}
    </Badge>
  )
}
